/* Christina Wishlist Page handler v2
   - Hydrates guest items using /products/{handle}.js (Ajax API)
   - Falls back to {gid:null,handle:null} legacy items by trying /products.json?limit=1 (skip)
   - Counter, remove, etc.

   T61 (2026-08-11) — DZIURA 2: lista goscia hydratuje sie z /products/<handle>.js,
   wiec cena przychodzi z Ajax API i NIE da sie jej zbramkowac w Liquid.
   Bramka po stronie klienta: tagi produktu (B2B / Professional) + globalna flaga
   window.__CC_B2B (ustawiana w layout/theme.liquid z customer.b2b?).
   Zablokowany produkt: zamiast kwoty tekst „Cena po weryfikacji", brak formularza
   „Do koszyka". Tag pro_approved NIE nadaje uprawnienia (regula T60).
*/
(function(){
  'use strict';
  var WISHLIST_KEY = 'christina_wishlist_local_v2';
  var WISHLIST_KEY_LEGACY = 'christina_wishlist_local';

  /* --- T61: bramka ceny Pro --------------------------------------------- */
  function ccEntitled(){
    return (typeof window.__CC_B2B !== 'undefined' && window.__CC_B2B === true);
  }
  function ccRestricted(p){
    var tags = (p && p.tags) || [];
    if (!tags.length) return false;
    return tags.some(function(t){ return /^(b2b|professional)$/i.test(String(t).trim()); });
  }
  function ccLocked(p){ return ccRestricted(p) && !ccEntitled(); }
  function ccLockedText(){
    var l = (document.documentElement.getAttribute('lang') || 'pl').toLowerCase();
    if (l.indexOf('zh') === 0) return '驗證後顯示價格';
    if (l.indexOf('en') === 0) return 'Price after verification';
    return 'Cena po weryfikacji';
  }

  function readLocal(){
    try {
      var raw = localStorage.getItem(WISHLIST_KEY);
      if (raw) return JSON.parse(raw);
      var legacy = localStorage.getItem(WISHLIST_KEY_LEGACY);
      if (legacy) {
        var arr = JSON.parse(legacy);
        return arr.map(function(g){ return typeof g === 'string' ? { gid: g, handle: null } : g; });
      }
      return [];
    } catch(e){ return []; }
  }
  function writeLocal(items){
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
      localStorage.setItem(WISHLIST_KEY_LEGACY, JSON.stringify(items.map(function(i){ return i.gid; })));
      window.dispatchEvent(new CustomEvent('christina:wishlist:changed', { detail: { items: items } }));
    } catch(e){}
  }

  function init(){
    var page = document.querySelector('[data-cb-wishlist-page]');
    if(!page) return;

    bindRemove(page);
    updateCounter(page);

    var hasServerItems = !!page.querySelector('[data-cb-wishlist-item]');
    var isLoggedIn = document.body.dataset.customerLoggedIn === 'true' || (window.__customer_logged_in === true);
    if(!hasServerItems && !isLoggedIn) hydrateGuestList(page);
  }

  function bindRemove(page){
    page.querySelectorAll('[data-cb-wishlist-remove]').forEach(function(btn){
      if (btn.dataset.cbBound) return;
      btn.dataset.cbBound = '1';
      btn.addEventListener('click', function(){
        var gid = btn.dataset.productGid;
        var item = btn.closest('[data-cb-wishlist-item]');
        if(!item) return;
        item.style.transition = 'opacity 0.25s, transform 0.25s';
        item.style.opacity = '0';
        item.style.transform = 'scale(0.95)';

        var items = readLocal();
        items = items.filter(function(x){ return x.gid !== gid; });
        writeLocal(items);

        var isLoggedIn = document.body.dataset.customerLoggedIn === 'true' || (window.__customer_logged_in === true);
        if(isLoggedIn) {
          fetch('/apps/christina/wishlist-toggle', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            keepalive: true,
            body: JSON.stringify({ product_gid: gid, action: 'remove' })
          }).catch(function(){});
        }

        setTimeout(function(){
          item.remove();
          updateCounter(page);
          if(!page.querySelector('[data-cb-wishlist-item]')) location.reload();
        }, 250);
      });
    });
  }

  function updateCounter(page){
    var count = page.querySelectorAll('[data-cb-wishlist-item]').length;
    var counter = page.querySelector('[data-cb-wishlist-count]');
    if(counter) {
      var noun = count === 0 ? 'produktów' : count === 1 ? 'produkt' : (count >= 2 && count <= 4) ? 'produkty' : 'produktów';
      counter.textContent = count + ' ' + noun;
    }
  }

  function hydrateGuestList(page){
    var items = readLocal();
    var withHandles = items.filter(function(i){ return i.handle; });
    if(!withHandles.length) {
      /* Legacy items without handles — show generic message */
      if(items.length) {
        var empty = page.querySelector('[data-cb-wishlist-empty]');
        if(empty) {
          empty.querySelector('h2').textContent = 'Twoja lista nie może być odtworzona';
          empty.querySelector('p').textContent = 'Lista zawiera produkty zapisane w starszej wersji. Wyczyść listę i dodaj produkty ponownie.';
          var btn = empty.querySelector('.cwp-btn');
          if(btn) {
            btn.textContent = 'Wyczyść listę';
            btn.href = '#';
            btn.addEventListener('click', function(e){ e.preventDefault(); localStorage.removeItem(WISHLIST_KEY); localStorage.removeItem(WISHLIST_KEY_LEGACY); location.reload(); });
          }
        }
      }
      return;
    }

    var empty = page.querySelector('[data-cb-wishlist-empty]');
    if(empty) empty.style.display = 'none';

    var grid = document.createElement('div');
    grid.className = 'cwp-grid';
    grid.setAttribute('data-cb-wishlist-grid', '');
    page.querySelector('.cwp-header').insertAdjacentElement('afterend', grid);
    grid.innerHTML = '<div style="grid-column:1/-1;text-align:center;padding:2rem;color:#888;font-size:.9rem">Ładowanie...</div>';

    Promise.all(withHandles.map(function(i){
      return fetch('/products/' + i.handle + '.js').then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; });
    })).then(function(results){
      grid.innerHTML = '';
      var rendered = 0;
      results.forEach(function(p, idx){
        if(!p) return;
        rendered++;
        grid.insertAdjacentHTML('beforeend', renderItem(p, withHandles[idx].gid));
      });
      if(rendered === 0) {
        grid.remove();
        if(empty) empty.style.display = '';
      } else {
        updateCounter(page);
        bindRemove(page);
        bindAddForms(page);
      }
    });
  }

  function bindAddForms(page){
    page.querySelectorAll('[data-cb-wishlist-add-form]').forEach(function(form){
      if(form.dataset.cbBound) return;
      form.dataset.cbBound = '1';
    });
  }

  function renderItem(p, gid){
    var v = p.variants && p.variants[0] ? p.variants[0] : {};
    var locked = ccLocked(p);
    var price = locked ? escapeHtml(ccLockedText()) : formatMoney(v.price);
    var compareAtRaw = v.compare_at_price;
    var hasCompare = !locked && compareAtRaw && parseFloat(compareAtRaw) > parseFloat(v.price);
    var compare = hasCompare ? formatMoney(compareAtRaw) : '';
    var img = p.featured_image || (p.images && p.images.length ? p.images[0] : '') || '';
    /* Ajax /products/{handle}.js returns images as array of URLs (strings) */
    if (typeof img !== 'string') img = img.src || '';
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    var available = !!v.available;
    var html = '<article class="cwp-item" data-cb-wishlist-item data-product-gid="' + gid + '"' + (locked ? ' data-cc-locked="1"' : '') + '>';
    html += '<button type="button" class="cwp-item-remove" data-cb-wishlist-remove data-product-gid="' + gid + '" aria-label="Usuń z listy życzeń">';
    html += '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>';
    html += '<a class="cwp-item-media" href="/products/' + p.handle + '" aria-label="' + escapeHtml(p.title) + '">';
    if(img) html += '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy">';
    html += '</a><div class="cwp-item-body">';
    if(p.vendor) html += '<span class="cwp-item-vendor">' + escapeHtml(p.vendor) + '</span>';
    html += '<a class="cwp-item-title" href="/products/' + p.handle + '">' + escapeHtml(p.title) + '</a>';
    html += '<div class="cwp-item-price"><span class="' + (locked ? 'cwp-item-price-locked' : 'cwp-item-price-current') + '">' + price + '</span>';
    if(hasCompare) html += '<span class="cwp-item-price-compare">' + compare + '</span>';
    html += '</div>';
    if(locked) {
      /* T61 — brak CTA do koszyka dla produktu Pro bez uprawnienia */
    } else if(available) {
      html += '<form action="/cart/add" method="post" data-cb-wishlist-add-form>';
      html += '<input type="hidden" name="id" value="' + v.id + '">';
      html += '<input type="hidden" name="quantity" value="1">';
      html += '<button type="submit" class="cwp-item-add">';
      html += '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';
      html += 'Do koszyka</button></form>';
    } else {
      html += '<span class="cwp-item-soldout">Niedostępny</span>';
    }
    html += '</div></article>';
    return html;
  }

  function formatMoney(cents){
    var n = parseFloat(cents) / 100;
    return n.toFixed(2).replace('.',',') + ' PLN';
  }
  function escapeHtml(s){
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
